import { createBrowserRouter, type RouteObject } from 'react-router';
import { SiteLayout, type RouteHandle } from '../shared/components/SiteLayout/SiteLayout';
import { routes } from '../shared/config/routes';
import { RouteError } from './RouteError';

/** Each page is its own lazily-loaded chunk (code splitting by route). */
const page = (load: () => Promise<{ default: React.ComponentType }>) => async () => ({ Component: (await load()).default });

const handle = (h: RouteHandle) => h;

export const routeObjects: RouteObject[] = [
  {
    element: <SiteLayout />,
    errorElement: <RouteError />,
    children: [
      { path: routes.home, lazy: page(() => import('../pages/HomePage')) },
      { path: routes.work, lazy: page(() => import('../pages/WorkPage')) },
      { path: routes.pricing, lazy: page(() => import('../pages/PricingPage')) },
      { path: routes.about, lazy: page(() => import('../pages/AboutPage')) },
      { path: routes.faq, lazy: page(() => import('../pages/FaqPage')) },
      { path: routes.audit, lazy: page(() => import('../pages/AuditPage')), handle: handle({ hideStickyCta: true }) },
      { path: routes.thanks, lazy: page(() => import('../pages/ThanksPage')), handle: handle({ hideStickyCta: true }) },
      { path: routes.links, lazy: page(() => import('../pages/LinksPage')), handle: handle({ bare: true }) },
      { path: routes.privacy, lazy: page(() => import('../pages/PrivacyPage')) },
      { path: routes.terms, lazy: page(() => import('../pages/TermsPage')) },
      { path: '*', lazy: page(() => import('../pages/NotFoundPage')) },
    ],
  },
];

export const createRouter = () => createBrowserRouter(routeObjects);
